// Define cmd like this instead of using googletag.CommandArray
//   because google hasn't replaced it with that yet.
export const dummyGoogleTag: {
    cmd: (() => unknown)[];
} = { cmd: [] };
export const getGoogleTag = (): typeof googletag => {
    const gt = window.googletag || dummyGoogleTag;
    return gt;
};
